import { useState, useEffect } from "react";
import { useEvent } from "../../../lib/hooks/useEvent";
import { useStencils } from "../../../lib/hooks/useStencils";
import {
  selectStencil,
  unselectStencil,
} from "../../../lib/services/stencilWeekService";

const QuickSelectModal = ({ onClose }) => {
  const { event } = useEvent();
  const { stencils } = useStencils();

  const [selectedWeek, setSelectedWeek] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [popupStencil, setPopupStencil] = useState(null);
  const [popupTimeout, setPopupTimeout] = useState(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    const stencil = stencils.find((s) => s.id === searchValue.trim());

    if (stencil) {
      const string = `isSelectedWeek${selectedWeek}`;
      const promise =
        stencil[string] === 0
          ? selectStencil(selectedWeek, stencil.id)
          : unselectStencil(selectedWeek, stencil.id);

      promise.then((response) => {
        if (!response.ok) alert(`Failed to update selection for ${stencil.id} for week ${selectedWeek}`);
      });

      setPopupStencil({ ...stencil });
      setSearchValue("");

      if (popupTimeout) clearTimeout(popupTimeout);
      const timeout = setTimeout(() => setPopupStencil(null), 3000);
      setPopupTimeout(timeout);
    }
  };

  return (
    <div className="quick-update-overlay" onClick={onClose}>
      <div
        className="quick-update-card"
        style={{ height: "60vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="quick-update-header">
          <h3>Quick Select</h3>
          <button className="btn-close" onClick={onClose}>
            Back
          </button>
        </div>

        <div className="quick-update-content">
          <div className="quick-update-step-buttons">
            <p>Select Stencil for week:</p>
            {[...Array(event?.num_weeks)].map((_, index) => (
              <button
                key={`${index + 1}`}
                className={`round-button ${
                  index + 1 === selectedWeek
                    ? `week${index + 1}-button-focused`
                    : `week${index + 1}-button`
                }`}
                onClick={() => {
                  if (selectedWeek === index + 1) setSelectedWeek(0);
                  else setSelectedWeek(index + 1);
                }}
              >
                Week {index + 1}
              </button>
            ))}
          </div>
          <div className="quick-update-search">
            <p>Enter a Stencil ID or scan the barcode</p>
            <form onSubmit={handleSearchSubmit}>
              <input
                type="text"
                id="search-bar"
                placeholder="Stencil ID"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </form>
          </div>
          {popupStencil && (
            <div className="quick-update-popup">
              <div>
                <p>{popupStencil.id}</p>
                <p>{popupStencil.name}</p>
                <p>
                  {!popupStencil[`isSelectedWeek${selectedWeek}`] ?
                  `Selected for Week ${selectedWeek}` :
                  `Unselected for Week ${selectedWeek}`  
                }
                </p>
              </div>
              <img
                key={popupStencil.image_name}
                src={`/api/stencils/files/${popupStencil.image_name}`}
                alt={popupStencil.name}
                width={100}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickSelectModal;
